/**
 * @desc 静态资源全局变量
 */
type staticResourceType = {
  [propName: string]: boolean | undefined
}

export const staticResource: staticResourceType = {};

export default staticResource;
